<template>
  <simple-modal 
    ref    = "zoneselect"
    :title = "$I18n('zone')"
    :large = "true"
    :right = "false"
    :submitBtn= "false"
  >
    <div slot="body" style="max-height: 80vh;overflow: auto;">
      <div class="md-layout" style="margin: 10px 0;">
        <!-- 字母 -->
        <div class="md-layout-item md-size-5" style="padding-top:10px; font-size: 16p;font-weight: 500;color: rgb(178,178,178);"></div>
        <!-- 选项 -->
        <div class="md-layout-item md-size-95 md-layout">
          <div @click="() => selectZone('ALL')" style="text-align: left;" class="click-box md-layout-item md-size-25">
            {{lang === 'zh' ?$I18n("all") :"ALL"}}
          </div>
        </div>
      </div>

      <div v-for="letter in letterArray" :key="letter" class="md-layout" style="margin: 10px 0;" 
        v-show="countryArray.filter(i => lang === 'zh' ?i.cn_sort === letter :i.en_sort === letter).length > 0">
        <!-- 字母 -->
        <div class="md-layout-item md-size-5" style="padding-top:10px; font-size: 16p;font-weight: 500;color: rgb(178,178,178);">{{letter}}</div>
        <!-- 选项 -->
        <div class="md-layout-item md-size-95 md-layout">
          <div @click="() => selectZone(item.code, item)" style="text-align: left;" v-for="item in countryArray.filter(i => lang === 'zh' ?i.cn_sort === letter :i.en_sort === letter)" :key="item.code" class="click-box md-layout-item md-size-25">
            {{lang === 'zh' ?item.cn_name :item.name}}
          </div>
        </div>
      </div>
    </div>
  </simple-modal>
</template>
<script>  
import {countryArray, letterArray} from "@/common/continent.js";
export default {
  data() {
    return {
      lang : this.$router.history.current.query.lang,
      countryArray,
      letterArray,
    }
  },
  methods: {
    open(){
      this.$refs.zoneselect.open();
    },
    close(){
      this.$refs.zoneselect.close();
    },
    selectZone(code, item){
      this.$emit("select", code, item)
      this.$refs.zoneselect.close();
    },
  }
}
</script>
<style lang="scss" scoped>
  .click-box{
    color: #000000;
    font-family: "宋体";
    // color: rgb(39, 46, 59);
    font-size: 14px;
    margin-top   : 5px;
    margin-bottom: 5px;
    padding: 5px;
    cursor :pointer;
  }
  .click-box:hover{
    background: #eeeeee;
  }
</style>